import { Box, Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { postAvailableCommodityOwnersApi } from "../../../../http/api/SalesPartitionSettingAPI";
import LoadingModal from "../../../../components/LoadingModal";

/**
 * 売買仕切書　帳票印刷設定フォーム
 */
const SalesPartitionSettingForm = ({printParameterInput, onCancel}) => {

  const [commodityOwners, setCommodityOwners] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const selectedCommodityOwnerCds = printParameterInput.value["commodityOwnerCds"];

  const hasSelectedCommodityOwnerCds = (commodityOwnerCd) => {
    return selectedCommodityOwnerCds?.findIndex((cd) => cd == commodityOwnerCd) >= 0;
  }

  useEffect (() => {
    (async () => {
      try {
        const commodityOwnerRes = await postAvailableCommodityOwnersApi({targetDate: printParameterInput.targetDate});
        setCommodityOwners(commodityOwnerRes.commodityOwners);
        printParameterInput.setPropValue(
          'commodityOwnerCds',
          commodityOwnerRes.commodityOwners.map((co) => co.commodityOwnerCd)
        );
        setLoading(false);
      } catch (err) {
        alert('選択可能な荷主の取得に失敗しました。');
        setLoading(false);
        onCancel();
      }
      
    })();      
      
  }, [])

  const onChangeChecked = (commodityOwnerCd) => (checked) => {

    const newCommodityOwnerCds = 
      checked 
        ? [...selectedCommodityOwnerCds, commodityOwnerCd]
        : selectedCommodityOwnerCds.filter((cd) => commodityOwnerCd !== cd);
    
    printParameterInput.setPropValue("commodityOwnerCds", newCommodityOwnerCds);
  };

  return (
    <>
      <Stack height="60vh">
        <Typography fontSize={20} fontWeight='bold'>売買仕切書 帳票印刷設定</Typography>
        <Box mt={2} sx={{overflowY: 'scroll'}}>
          {CommodityOwnerItems(isLoading, commodityOwners, (co) => (
            <TargetCommodityOwnerCheckBox
              value={co.commodityOwnerName}
              checked={hasSelectedCommodityOwnerCds(co.commodityOwnerCd)}
              onChangeChecked={onChangeChecked(co.commodityOwnerCd)}
              label={co.commodityOwnerName}
            />
          ))}
        </Box>
      </Stack>
      <LoadingModal
        open={isLoading}
        label={"取得中"}
      />
    </>
      
  );
};

export default SalesPartitionSettingForm;

/**
 * 売買通知書入力初期値 
 */
export const salesPartitionDefaultParameter = {
  commodityOwnerCds : [],
}

/**
 * 売買仕切書入力値バリデーション
 */
export const validateSalesPartition = (formValue) => {  
  return formValue?.commodityOwnerCds && formValue.commodityOwnerCds.length > 0
};

/**
 * 売買仕切フォームの値を返す
 */
export const returnSalesPartitionParameter = (formValue) => (validateSalesPartition(formValue) ? {
  targetCommodityOwnerCds: formValue.commodityOwnerCds             
} : null);

/**
 * 荷主リスト部分の内容
 */
const CommodityOwnerItems = (isLoading, commodityOwners, CommodityOwnerItemComponent) => {
  if (isLoading) {
    return null;
  }
  if (commodityOwners.length === 0) {
    return <Typography fontSize={15}>対象となる荷主が存在しません。</Typography>;
  }

  return commodityOwners.map((co) => (
          (CommodityOwnerItemComponent(co))
        ));
}

/**
 * 出力対象荷主情報　ラジオボタンフォームコントロール
 */
const TargetCommodityOwnerCheckBox = ({value, checked, onChangeChecked, label}) => (
  <Box>
    <FormControlLabel
      label={label}
      sx={{marginLeft: 1}}
      control = {
        <Checkbox
          value={value}
          checked={checked}
          onChange={(e) => onChangeChecked(e.target.checked)}
        />
      }
    />
  </Box>
);
